import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Colors, ModalProps } from 'Types';
import {
	Button,
	FontAwesome,
	ModalBox,
	ModalBoxFooter,
	SubmitButton
} from 'Elements';

interface Props extends ModalProps {
	isOpen: boolean;
	onClose: () => void;
	onSubmit?: () => void;
	isSubmitting: boolean;
	user: string;
}
export const ConfirmRemoveUser: FC<Props> = ({
	isOpen,
	onClose,
	onSubmit,
	isSubmitting,
	user
}) => {
	const { t } = useTranslation();

	return (
		<ModalBox
			isOpen={isOpen}
			onClose={onClose}
			title={t('title.confirm-delete-user')}>
			<header className="d-flex flex-column align-items-center text-center px-3">
				<FontAwesome
					icon="triangle-exclamation"
					size="8x"
					className="mb-3 text-warning"
				/>
				<h6 className="h6 lh-base">
					{t('title.delete-user-confirmation', {
						user: user
					})}
				</h6>
			</header>
			<ModalBoxFooter className="justify-content-between pt-3">
				<Button color={Colors['white-gray']} onClick={onClose}>
					{t('button.cancel')}
				</Button>
				<SubmitButton
					type="button"
					icon=""
					isSubmitting={isSubmitting}
					label={t('label.delete')}
					savingLabel=""
					onClick={onSubmit}
				/>
			</ModalBoxFooter>
		</ModalBox>
	);
};

ConfirmRemoveUser.displayName = 'ConfirmRemoveUser';
